import { render, staticRenderFns } from "./homeComponent.vue?vue&type=template&id=5d4eb8fb&scoped=true&"
import script from "./homeComponent.vue?vue&type=script&lang=js&"
export * from "./homeComponent.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=5d4eb8fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4eb8fb",
  null
  
)

export default component.exports